module.exports = __webpack_public_path__ + "static/images/finance-7.5c2a95d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/solution/finance-7.png
// module id = jmW4
// module chunks = 8